import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SearchSimple from '../../../components/SearchSimples/SearchSimple';
import NotInformation from '../../../components/NotInformation';
import { CustomCheckbox } from '../../../components/CustomCheckbox';
import CustomCard from '../../../components/CustomCard';
import RowCardText from '../../../components/RowCardText';
import TemplateCardPreview from './TemplateCardPreview';
import TemplatesCardsApp from '../Functionality/TemplatesCardsApp';
import { permissionObj } from '../../../Helpers/permission';
import ButtonActionsCard from '../../../components/buttons/ButtonActionsCard';
import routes from '../../../Routes/routes';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TemplatesCards = ({
    view,
    option,
    setBodyForExport,
    selectedList,
    setSelectedList,
    searchElement,
    setSearchElement,
    isAllChecked,
    setIsAllChecked,
    modified,
    setModified,
    setSearch,
    simpleSearch,
    setSimpleSearch
}) => {
    const {
        rowsPerPage,
        contractorId,
        supplierId,
        t,
        DEV,
        permission,
        handleDeleteAll,
        handleCheckboxChange,
        cardWidth,
        cardHeight,
        cardBackgroundColor,
        stageFront,
        stageBack,
        pagination,
        navigate,
        results,
        setResults,
        elementRef
    } = TemplatesCardsApp({
        view,
        option,
        selectedList,
        setSelectedList,
        setBodyForExport,
        searchElement,
        setIsAllChecked,
        modified,
        setModified
    });

    // Without update access the card only opens the read only details view
    const canCreateTemplate = DEV || permission?.includes(permissionObj?.WEB_CARD_DESIGNER_CREATE);
    const canUpdateTemplate = DEV || permission?.includes(permissionObj?.WEB_CARD_DESIGNER_UPDATE);
    const canReadTemplate = DEV || permission?.includes(permissionObj?.WEB_CARD_DESIGNER_READ);

    return (
        <>
            <div className={'col-12 mb-4'}>
                <SearchSimple
                    id={'txt_cdp_search_simple'}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearchResults={setResults}
                    setBodyForExport={setBodyForExport}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={contractorId}
                    supplierId={supplierId}
                />
            </div>

            {results && results?.content?.length > 0 ? (
                <>
                    <div className='col-12'>
                        {(DEV || permission?.includes(permissionObj?.WEB_CARD_DESIGNER_DELETE)) && (
                            <CustomCheckbox
                                trans={t('de_/_select_all')}
                                checked={isAllChecked}
                                onChange={handleDeleteAll}
                                disabled={
                                    !results?.content?.length ||
                                    results?.content[0]?.whoCreatedId === undefined
                                }
                            />
                        )}
                    </div>
                    <div className='panelTables d-flex flex-wrap-no-gap px-1' ref={elementRef}>
                        <>
                            {results?.content[0].whoCreatedId !== undefined ? (
                                <>
                                    {results?.content?.map((item) => {
                                        const raw = JSON.parse(item?.raw);
                                        for (let key in raw) {
                                            raw[key].combinedObject.forEach((item) => {
                                                if (item.liveContent === 'userSelfie') {
                                                    item.base64 = '/static/media/userDemoImg.1a05a7d972162c340842.png';
                                                }
                                            });
                                        }

                                        return (
                                            <div className='col-6 col-sm-4 col-md-3 col-lg-3 mb-2  px-1' key={item?.id}>
                                                <CustomCard
                                                    classCard={`${
                                                        selectedList?.includes(item?.id)
                                                            ? 'background-error-code-50 border-full-error-code-400 selected-card'
                                                            : ''
                                                    }`}
                                                >
                                                    <div className='h-100 card-template'>
                                                        <div className='top-heading-card'>
                                                            {(DEV ||
                                                                permission?.includes(
                                                                    permissionObj?.WEB_CARD_DESIGNER_DELETE
                                                                )) && (
                                                                <CustomCheckbox
                                                                    checked={selectedList?.includes(
                                                                        item?.id
                                                                    )}
                                                                    id={item?.id}
                                                                    onChange={handleCheckboxChange}
                                                                />
                                                            )}
                                                        </div>
                                                        <div className='card-body-grid '>
                                                            <div className='p-2'>
                                                                <RowCardText title={t('name')} value={item?.name} />
                                                                <div className='row no-grid-gap contentImgCard'>
                                                                    <div className='col-6 preview'>
                                                                        <div className='preview-container'>
                                                                            <TemplateCardPreview
                                                                                item={item}
                                                                                cardWidth={cardWidth}
                                                                                cardHeight={cardHeight}
                                                                                cardBackgroundColor={
                                                                                    cardBackgroundColor
                                                                                }
                                                                                stageRef={stageFront}
                                                                                isFront={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-6 preview'>
                                                                        <div className='preview-container'>
                                                                            <TemplateCardPreview
                                                                                item={item}
                                                                                cardWidth={cardWidth}
                                                                                cardHeight={cardHeight}
                                                                                cardBackgroundColor={
                                                                                    cardBackgroundColor
                                                                                }
                                                                                stageRef={stageBack}
                                                                                isFront={false}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {(canUpdateTemplate || canReadTemplate) && (
                                                            <div className='d-flex justify-content-end'>
                                                                <ButtonActionsCard
                                                                    id={`btn_actions_card_${item?.id}`}
                                                                    name={canUpdateTemplate ? 'update' : 'details'}
                                                                    Icon={KeyboardArrowRightIcon}
                                                                    onClick={() => {
                                                                        navigate(canUpdateTemplate
                                                                            ? routes.cardDesigner.create
                                                                            : routes.cardDesigner.details, {
                                                                            state: { itemSelected: item },
                                                                        });
                                                                    }}
                                                                    className='btn-icon-hover-grey'
                                                                    iconProps='btn-icon-svg-12px btn-icon-svg-dark'
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </CustomCard>
                                            </div>
                                        );
                                    })}
                                </>
                            ) : null}
                        </>
                    </div>

                    <div className='col-12'>{pagination()}</div>
                </>
            ) : (
                <div className='col-12'>
                    <NotInformation
                        text={typeof results?.content === 'undefined'
                            ? t('loading')
                            : t('you_haven_not_created_any_template_yet')}
                        card={true}
                        showButton={canCreateTemplate}
                        buttonId={'btn_tc_create'}
                        buttonTrans={'create_new_template'}
                        buttonOnclick={() => navigate(routes.cardDesigner.create)}
                    />
                </div>
            )}
        </>
    );
};

export default TemplatesCards;
